export default "/assets/images/filter-basic-breather-box.png?1041a2e79b8effdce8604f1b207f0b37";